import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
interface HeaderProps {
  forceSolid?: boolean;
}
export function Header({
  forceSolid = false
}: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const isSolid = forceSolid || isScrolled;
  const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.location.hash = '#/';
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    const currentHash = window.location.hash;
    const isOnLandingPage = currentHash === '#/' || currentHash === '';
    if (!isOnLandingPage) {
      // Navigate to landing page first
      window.location.hash = '#/';
      // Wait for navigation, then scroll
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // Already on landing page, just scroll immediately
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const navLinks = [{
    name: 'Leistungen',
    targetId: 'services'
  }, {
    name: 'Über uns',
    targetId: 'about'
  }, {
    name: 'Kontakt',
    targetId: 'contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isSolid ? 'bg-white shadow-md py-4' : 'bg-transparent py-6'}`} data-id="element-79">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <div className="flex justify-between items-center" data-id="element-81">
          <div className="flex items-center" data-id="element-82">
            <a href="#/" onClick={handleLogoClick} className={`text-2xl font-bold tracking-tight ${isSolid ? 'text-blue-900' : 'text-white'}`} data-id="element-83">
              ellner<span className="font-light" data-id="element-84">consultancy</span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-85">
            {navLinks.map(link => <a key={link.name} href={`#${link.targetId}`} onClick={e => handleNavClick(e, link.targetId)} className={`text-sm font-medium transition-colors hover:text-blue-400 ${isSolid ? 'text-slate-700' : 'text-slate-200'}`} data-id="element-86">
                {link.name}
              </a>)}
            <a href="#contact" onClick={e => handleNavClick(e, 'contact')} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${isSolid ? 'bg-blue-900 text-white hover:bg-blue-800' : 'bg-white text-blue-900 hover:bg-slate-100'}`} data-id="element-87">
              Beratung anfragen
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-88">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`p-2 rounded-md ${isSolid ? 'text-slate-900' : 'text-white'}`} aria-label="Menu" data-id="element-89">
              {isMobileMenuOpen ? <X size={24} data-id="element-90" /> : <Menu size={24} data-id="element-91" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white absolute top-full left-0 right-0 shadow-lg border-t border-slate-100" data-id="element-92">
          <div className="px-4 py-6 space-y-4 flex flex-col" data-id="element-93">
            {navLinks.map(link => <a key={link.name} href={`#${link.targetId}`} onClick={e => handleNavClick(e, link.targetId)} className="text-slate-800 font-medium hover:text-blue-600 transition-colors" data-id="element-94">
                {link.name}
              </a>)}
            <a href="#contact" onClick={e => handleNavClick(e, 'contact')} className="inline-block text-center px-4 py-3 bg-blue-900 text-white rounded-md font-medium hover:bg-blue-800 transition-colors" data-id="element-95">
              Beratung anfragen
            </a>
          </div>
        </div>}
    </header>;
}